
import styles from './inicio.module.css'
import PostCard from "Componentes/PostCard";

import posts from 'json/posts.json'

export default function Inicio() {
    return (

            <ul className={styles.posts}>
        {posts.map((post) => (
            <li key={post.id}>
            <PostCard post={post} />
            </li>
        ))}
            </ul>
    )
}